export const HAMBURGARE_TOGGLE = 'burgare/HAMBURGARE_TOGGLE';
